import img1 from "../../assets/images/s1.jpg"
import img2 from "../../assets/images/s2.jpg"
import img3 from "../../assets/images/s3.jpg"
import img4 from "../../assets/images/s4.jpg"
import img5 from "../../assets/images/s5.jpg"


export const SliderData = [
    {
      image: img1
    },
    {
      image:img2
    },
    {
      image:img3
    },
    {
      image:img4
    },
    {
      image: img5
    }
  ];